import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {NgSelectComponent} from '@ng-select/ng-select';
import {UserInformationFields} from '../../constants/user-information-fields';
import {Select} from 'primeng/select';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-user-information',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    NgSelectComponent,
    Select
  ],
  template: `
    <div class="form-row flex-align-center">
      <label>{{ Yii.t('app', 'Source Field') }}</label>
      <div>
        <ng-select
          style="max-width: 480px;width: 100%"
          bindValue="key"
          bindLabel="tag"
          appendTo="body"
          [multiple]="true"
          [hideSelected]="true"
          [items]="listOfPredefinedValues"
          [(ngModel)]="field.source_field"
        />
      </div>
    </div>

    <div class="form-row flex-align-center">
      <label>{{ Yii.t('app', 'Part of system') }}</label>
      <div>
        <p-select
          [options]="partsOfSystem"
          [(ngModel)]="field.part_of_system"
          optionLabel="tag"
          optionValue="value"
          appendTo="body"
        />
      </div>
    </div>
  `,
})
export class FieldUserInformation {
  Yii = Yii;
  @Input() field: any;
  public listOfPredefinedValues = UserInformationFields
  public partsOfSystem = [
    {"tag": "None", "value": ""},
    {"tag": "Form Filler", "value": "form_filler"},
    {"tag": "Selected User", "value": "pick_user"}
  ]
}
